var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C3.44772 0 3 0.447715 3 1V2H2C0.895431 2 0 2.89543 0 4V12C0 13.1046 0.89543 14 2 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2H11V1C11 0.447715 10.5523 0 10 0C9.44771 0 9 0.447715 9 1V2H5V1C5 0.447715 4.55228 0 4 0ZM12 4V5H2V4H12ZM2 7V12H12V7H2Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCalender);
export default __webpack_public_path__ + "static/media/input_calender.a2f9a09efdb13a5a036b6565e82fd694.svg";
export { ForwardRef as ReactComponent };